/**
 * Google Analytics 4 Integration Card
 *
 * Provides direct link to Google Analytics 4 dashboard
 * No fake data - just a clean interface to access real GA4 analytics
 */

import { ExternalLink, BarChart3 } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export function GA4Charts() {
  return (
    <Card className="bg-gradient-to-r from-blue-50 to-purple-50 border-2 border-blue-200">
      <CardHeader>
        <div className="flex items-center gap-3 mb-2">
          <div className="p-3 bg-blue-100 rounded-lg">
            <BarChart3 className="h-6 w-6 text-blue-600" />
          </div>
          <div>
            <CardTitle className="text-blue-900">Google Analytics 4</CardTitle>
            <CardDescription className="text-blue-700">
              View real-time analytics and detailed reports in your GA4
              dashboard
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <p className="text-sm text-blue-800">
            Google Analytics 4 is tracking your website traffic, user behavior,
            and conversions. Click below to access your complete analytics
            dashboard with real-time data.
          </p>

          <div className="flex gap-3">
            <a
              href="https://analytics.google.com/analytics/web/#/p513659506/reports/intelligenthome"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1"
            >
              <Button
                size="lg"
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold"
              >
                <ExternalLink className="h-5 w-5 mr-2" />
                Open Google Analytics Dashboard
              </Button>
            </a>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 pt-4 border-t border-blue-200">
            <a
              href="https://analytics.google.com/analytics/web/#/p513659506/reports/intelligenthome"
              target="_blank"
              rel="noopener noreferrer"
              className="text-center p-3 bg-white rounded-lg hover:bg-blue-50 transition-colors"
            >
              <div className="text-2xl mb-1">📊</div>
              <div className="text-xs font-semibold text-blue-900">
                Real-Time
              </div>
            </a>
            <a
              href="https://analytics.google.com/analytics/web/#/p513659506/reports/reportinghub"
              target="_blank"
              rel="noopener noreferrer"
              className="text-center p-3 bg-white rounded-lg hover:bg-blue-50 transition-colors"
            >
              <div className="text-2xl mb-1">📈</div>
              <div className="text-xs font-semibold text-blue-900">
                Overview
              </div>
            </a>
            <a
              href="https://analytics.google.com/analytics/web/#/p513659506/reports/acquisition-overview"
              target="_blank"
              rel="noopener noreferrer"
              className="text-center p-3 bg-white rounded-lg hover:bg-blue-50 transition-colors"
            >
              <div className="text-2xl mb-1">🎯</div>
              <div className="text-xs font-semibold text-blue-900">
                Acquisition
              </div>
            </a>
            <a
              href="https://analytics.google.com/analytics/web/#/p513659506/reports/engagement-overview"
              target="_blank"
              rel="noopener noreferrer"
              className="text-center p-3 bg-white rounded-lg hover:bg-blue-50 transition-colors"
            >
              <div className="text-2xl mb-1">💬</div>
              <div className="text-xs font-semibold text-blue-900">
                Engagement
              </div>
            </a>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
